// extracted by mini-css-extract-plugin
export default {"animation":"styles_animation__BpkeC"};